module.exports = __webpack_public_path__ + "img/zhanli7.08fc862f.jpg";